export default "__VITE_ASSET__ByX7e6sH__"